<template>
  <error-page :code="$route.params.type"></error-page>
</template>

<script>
export default {
  name: 'Error'
}
</script>
